import { Box, debounce } from '@mui/material';
import ReactECharts from 'echarts-for-react';
import LoaderComponent from 'components/Loader';
import { defaultOptions, getLineChartOptions } from './chartWidgetUtility';
import { useEffect, useRef, useState } from 'react';
import { AreaLineChartWidgetProps } from './type';
import { useTheme } from "@mui/material/styles";

const AreaLineChartWidget = ({
	isLoading = false,
	data,
	colorMapping,
	gradientMapping,
	hasLegend,
	handleEvent
}: Readonly<AreaLineChartWidgetProps>) => {
	const theme= useTheme();
	const colors = theme.palette;
	const [, setWindowSize] = useState(window.innerWidth);
	const [gridLeft] = useState('9%');
	const chartContainerRef = useRef<HTMLDivElement>(null);
	const chartRef = useRef<any>(null);

	useEffect(() => {
		// re-render chart to fix alignment when resizing the browser
		const handleResize = debounce(() => {
			if (chartContainerRef.current) {
				setWindowSize(window.innerWidth);
			}
			if (chartRef.current) {
				chartRef.current.getEchartsInstance().resize();
			}
		}, 200);

		handleResize();
		window.addEventListener('resize', handleResize);
		return () => {
			window.removeEventListener('resize', handleResize);
		};
	}, []);

	const result = getLineChartOptions(data ?? {}, colorMapping ?? [], gradientMapping ?? [], hasLegend, colors);
	const { chartOption } = result;

	const adjustedOption: any =
		!chartOption || Object.keys(chartOption).length === 0 
			? defaultOptions
			: {
				...chartOption,
				grid: {
					...chartOption.grid,
					left: gridLeft
				} 
			}

	return (
		<Box
			sx={{
				flex: '55%',
				textAlign: 'center',
				justifyContent: 'center',
				paddingLeft: '16px', // Adjusts spacing between border and content
				paddingRight: '8px', // Adjusts spacing on the right side
				// cursor: !hasLegend ? 'pointer' : 'default',
				cursor: 'default',
			}}
			// {...(handleEvent && { onClick: !hasLegend ? handleEvent : undefined })}
			{...(handleEvent && { onClick: undefined })}
		>
			{!isLoading ? (
				<ReactECharts
					ref={chartRef}
					option={adjustedOption}
					style={{ width: '100%', height: '100%' }}
					opts={{ renderer: 'canvas', width: 'auto' }}
					notMerge={true}
					lazyUpdate={true}
				/>
			) : (
				<LoaderComponent />
			)}
		</Box>
	);
};

export default AreaLineChartWidget;
